import { ACTION_TYPE } from "./actions";

export const SHARE_OPEN_LINK_ACTION = {
  label: "advisor.clients.info.kebabMenu.openLink",
  icon: "n:open-link",
  type: ACTION_TYPE.OPEN_LINK,
};

export const SHARE_COPY_LINK_ACTION = {
  label: "advisor.clients.info.kebabMenu.copyLink",
  icon: "n:copy-link",
  type: ACTION_TYPE.COPY_LINK,
};

export const SHARE_OPEN_LINK_V2_ACTION = {
  label: "portfolioFetcherV2.openCollectionLink",
  icon: "n:open-link",
  type: ACTION_TYPE.OPEN_LINK_V2,
};

export const SHARE_COPY_LINK_V2_ACTION = {
  label: "portfolioFetcherV2.copyCollectionLink",
  icon: "n:copy-link",
  type: ACTION_TYPE.COPY_LINK_V2,
};

export const CLEAR_CREDENTIALS_ACTION = {
  label: "advisor.clients.info.action.clear-connection-credentials",
  icon: "n:unlink",
  type: ACTION_TYPE.CLEAR_CREDS,
};

export const CREATE_PORTFOLIO_PROPOSAL_ACTION = {
  label: "advisor.clients.create-portfolio",
  icon: "n:portfolio-outline",
  type: ACTION_TYPE.CREATE_PORTFOLIO,
};

export const CLIENTS_PERMISSIONS = {
  MANAGE: "PERMISSIONS.CLIENTS.MANAGE",
  CLEAR_CREDENTIALS: "PERMISSIONS.CLIENTS.CLEAR_CREDENTIALS",
  RISK_DETAILS: "PERMISSIONS.CLIENTS.RISK_DETAILS",
};
